import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import {
  ModalOverlay,
  ConfirmationModal,
  ModalTitle,
  ModalMessage,
  ModalButtons
} from './css';

const DeleteModal = ({ deleteConfirm, onConfirm, onCancel, DEVICE_MATRIX }) => {
  if (!deleteConfirm) return null;

  return (
    <ModalOverlay onClick={onCancel}>
      <ConfirmationModal onClick={(e) => e.stopPropagation()}>
        <ModalTitle>{(DEVICE_MATRIX.BUTTONS && DEVICE_MATRIX.BUTTONS.DELETE) || 'Delete'}</ModalTitle>
        <ModalMessage>
          {((DEVICE_MATRIX.MESSAGES && DEVICE_MATRIX.MESSAGES.DELETE_CONFIRMATION) || 'Are you sure you want to delete this device?').replace('this device', `"${deleteConfirm.name}"`)}
        </ModalMessage>
        <ModalButtons>
          <Button variant={{ priority: 'low' }} onPress={onCancel}>
            {(DEVICE_MATRIX.BUTTONS && DEVICE_MATRIX.BUTTONS.CANCEL) || 'Cancel'}
          </Button>
          <Button variant={{ priority: 'high', semantic: 'danger' }} onPress={onConfirm}>
            {(DEVICE_MATRIX.BUTTONS && DEVICE_MATRIX.BUTTONS.DELETE) || 'Delete'}
          </Button>
        </ModalButtons>
      </ConfirmationModal>
    </ModalOverlay>
  );
};

DeleteModal.propTypes = {
  deleteConfirm: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  DEVICE_MATRIX: PropTypes.shape({
    BUTTONS: PropTypes.shape({
      DELETE: PropTypes.string,
      CANCEL: PropTypes.string
    }),
    MESSAGES: PropTypes.shape({
      DELETE_CONFIRMATION: PropTypes.string
    })
  }).isRequired
};

export default DeleteModal;
